<template>
  <div class="relative h-full f-col" :class="{ 'bg-white': whiteBackground }">
    <base-button
      v-if="quickshop"
      :aria-describedby="id"
      :aria-label="$t.add"
      class="group absolute right-0 top-0 z-3 p-1"
      data-test-id="product-card-add"
      @click="handleQuickshop($event)"
    >
      <span class="block rounded-xs p-1 duration lg:m-2 forced-colors:bg-[ButtonFace] group-hover:bg-brand-2">
        <vf-icon :height="{ sm: '20', lg: '24' }" name="plus" :width="{ sm: '20', lg: '24' }" />
      </span>
    </base-button>
    <base-picture
      :alt="image.alt"
      v-bind="size"
      class="w-full"
      :src="getResponsiveImageTransformations(image.src, {
        ...size,
        ...transformations,
      })"
    />
    <div v-style:c="textColor" class="f-col gap-1 p-2">
      <base-link
        :id
        class="line-clamp-2 self-start subtitle-4"
        :to="{
          path: url,
          state: searchType ? { category: `Search: ${searchType}`, searchType, suggestedPhrase } : {},
        }"
        @click="$emit('product-click', $event)"
      >
        {{ title }}
        <span class="absolute-0" />
      </base-link>
      <product-pricing
        class="subtitle-5"
        :currency
        :price
        :show-discount-percentage="$feature.showDiscountPercentageOnCatalog"
      />
    </div>
    <panel-quickshop />
  </div>
</template>

<script lang="ts" setup>
import type { RecommendationStyle } from '#content/contexts/recommendation'
import type { ProductVariants } from '#root/api/clients/product/data-contracts'
import type { ProductCardRecommendedProps } from '#types/components/cms/product-card-recommended'
import type { HistoryState } from 'vue-router'
import { RecommendationStyleContextKey } from '#content/contexts/recommendation'

const {
  currency,
  gtmConfig,
  id,
  image,
  price,
  quickshop = true,
  title,
  url,
  variant,
} = defineProps<ProductCardRecommendedProps>()

const emit = defineEmits<{ 'product-click': [e: PointerEvent] }>()

const { size: imageSizeMap, transformations } = useAppConfig().components.cms.productRecommendations.presets
const size = imageSizeMap[variant]
const route = useRoute()

const searchType = inject('searchType', undefined) as HistoryState | undefined
const suggestedPhrase = inject('suggestedPhrase', undefined) as HistoryState | undefined

const product = computed(() => ({
  id,
  name: title,
  url,
  price,
  currency,
  attributes: [],
  variants: {} as ProductVariants,
}))

const closeQuickshopOnAdd = route.name?.toString().includes('cart')

const PanelQuickshop = createPanel('quickshop')

const handleQuickshop = (e: PointerEvent) => {
  emit('product-click', e)
  PanelQuickshop.keep().open({ product: product.value, closeOnAdd: closeQuickshopOnAdd, gtmConfig })
}

const { textColor, whiteBackground } = inject(RecommendationStyleContextKey, {} as RecommendationStyle)
</script>
